import './bootstrap';
import '../css/app.css';
import 'primevue/resources/themes/lara-light-green/theme.css'
import 'primeicons/primeicons.css'
import 'flowbite';
import { DefineComponent, createApp, h, nextTick } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import AutoComplete from 'primevue/autocomplete';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import DialogService from 'primevue/dialogservice';
import ConfirmationService from 'primevue/confirmationservice';
import PanelMenu from 'primevue/panelmenu';
import InputText from 'primevue/inputtext';
import Image from 'primevue/image';
import Button from 'primevue/button';
import Badge from 'primevue/badge';
import SpeedDial from 'primevue/speeddial';
import Checkbox from 'primevue/checkbox';
import MultiSelect from 'primevue/multiselect';
import RadioButton from 'primevue/radiobutton';
import Card from 'primevue/card';
import Chart from 'primevue/chart';
import Dropdown from 'primevue/dropdown';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row'; 
import Paginator from 'primevue/paginator';
import Toast from 'primevue/toast';
import Fieldset from 'primevue/fieldset';
import Breadcrumb from 'primevue/breadcrumb';
import Dialog from 'primevue/dialog';
import SplitButton from 'primevue/splitbutton';
import DynamicDialog from 'primevue/dynamicdialog';
import PickList from 'primevue/picklist';
import Listbox from 'primevue/listbox';
import Tag from 'primevue/tag';
import Textarea from 'primevue/textarea';
import Editor from 'primevue/editor';
import Password from 'primevue/password';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Calendar from 'primevue/calendar';
import InputIcon  from 'primevue/inputicon'
import FileUpload from 'primevue/fileupload';
import ConfirmDialog from 'primevue/confirmdialog';
import Sidebar from 'primevue/sidebar';
import TreeTable from 'primevue/treetable';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { createPinia } from 'pinia';
import Ripple from 'primevue/ripple';
import Menubar from 'primevue/menubar';
import Carousel from 'primevue/carousel';
import DataView from 'primevue/dataview';
import SelectButton from 'primevue/selectbutton';
import clickOutside from '@/directives/ClickOutsite'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent<DefineComponent>(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(PrimeVue, { ripple: false, unstyled: false })
            .use(ToastService)
            .use(DialogService)
            .use(ConfirmationService)
            .use(pinia)
            .directive('click-outside', clickOutside)
            .component('AutoComplete', AutoComplete)
            .component('PanelMenu', PanelMenu)
            .component('InputText',InputText)
            .component('Button', Button)
            .component('Menubar', Menubar)
            .component('Carousel', Carousel)
            .component('Toast', Toast)
            .component('DataView', DataView)
            .component('SelectButton', SelectButton)
            .component('Tag', Tag)
            .component('Checkbox', Checkbox)
            .component('RadioButton', RadioButton)
            .component('Badge', Badge)
            .component('Card', Card)
            .component('Chart', Chart)
            .component('Dropdown', Dropdown)
            .component('DataTable', DataTable)
            .component('Column', Column)
            .component('ColumnGroup', ColumnGroup)
            .component('Paginator', Paginator)
            .component('PickList', PickList)
            .component('Fieldset', Fieldset)
            .component('Listbox', Listbox)
            .component('MultiSelect', MultiSelect)
            .component('Row', Row)
            .component('Sidebar', Sidebar)
            .component('Image', Image)
            .component('SplitButton', SplitButton)
            .component('Breadcrumb', Breadcrumb)
            .component('TabView', TabView)
            .component('TabPanel ', TabPanel)
            .component('Tag ', Tag)
            .component('Dialog', Dialog)
            .component('DynamicDialog', DynamicDialog)
            .component('Textarea', Textarea)
            .component('Editor', Editor)
            .component('Password', Password)
            .component('Calendar', Calendar)
            .component('InputIcon', InputIcon)
            .component('FileUpload', FileUpload)
            .component('ConfirmDialog', ConfirmDialog)
            .component('SpeedDial', SpeedDial)
            .component('TreeTable', TreeTable)
            .directive("ripple", Ripple)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
